import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'primereact/button';

const HintsNoData = ({ onAdd, children }) => (
  <div className="panel-body">
    <p className="align-center">{children}</p>
    <div className="align-center">
      <FormattedMessage id="actions.add" defaultMessage="Add">
        {text => <Button type="button" onClick={onAdd} label={text} />}
      </FormattedMessage>
    </div>
  </div>
);

HintsNoData.propTypes = {
  onAdd: PropTypes.func.isRequired,
  children: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default HintsNoData;
